define([
	"./_Plugin",
	"./_GroupUngroup",
	"./PluginFactory",
	"./util"
], function(_Plugin,_GroupUngroup, PluginFactory,util) {

	return PluginFactory.declare(_GroupUngroup, {
		iconClass: "csiActionIcon svgIconGroup",
		pluginName: "group",
		title: "CanvasGroup",
		tagShape: "g",

		enablePlugin: function(/*Shape[]*/shapes, /*Object*/shapeAttrs, /*Object*/textAttrs) {
			// summary: only enable if more than one selected shape
			return this.inherited(arguments) && shapes && util.unlockedShapedCount(shapes) > 1 && !this.editor.isSubgroupSelected();
		},

		onClick: function(/*Event*/e) {
			// summary: group selected shapes
			this.editor.groupSelection();

			// track operation for undo/redo
			this.editor.push();
		}
	});
});
